<template>
  <zg-module
    v-bind="moduleProps"
    class="zg-cross-sell-section"
  >
    <slot
      slot="sub-title"
      name="sub-title"
    />

    <zg-grid
      v-if="items && items.length"
      :columns="1"
      :m-columns="2"
      :l-columns="3"
      class="grid"
    >
      <zg-cross-sell
        v-for="(item, index) in items"
        :key="index"
        :title="item.title"
        :sub-title="item.subTitle"
        :usps="item.usps"
        :button="item.button"
        :button-type="buttonType"
        :product="item.product"
        :background="item.background || cardBackground"
        :illustration="item.illustration"
        :illustration-on-clouds="item.illustrationOnClouds"
        full-width
      />
    </zg-grid>
  </zg-module>
</template>

<script>
  import module from '../../../mixins/module.js'
  import ZgGrid from '../../layout/grid/ZgGrid.vue'
  import ZgCrossSell from '../../ZgCrossSell/ZgCrossSell.vue'
  import ZgModule from '../ZgModule/ZgModule.vue'

  export default {
    name: 'ZgCrossSellSection',
    components: {
      ZgModule,
      ZgGrid,
      ZgCrossSell
    },
    mixins: [module],
    props: {
      items: {
        type: Array,
        required: true
      },
      buttonType: {
        type: String,
        required: false,
        default: 'button',
        validator: value => [
          'button',
          'chevron',
          'link'
        ].includes(value)
      },
      linkType: {
        type: String,
        required: false,
        default: null
      }
    }
  }
</script>
